import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select, Input } from "antd";
import { ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { Tooltip } from "@vds/tooltips";
import CircleIIcon from "../../../../../assets/circle_i.svg";
import ATSToolTip from "../../../../../global/components/ATSToolTip";
import { updateUI } from "../../../../../store/actions/deviceProfile";
import {
  MAX_CHAR_LIMITS,
  getCharLimitMsgDeviceProfile,
} from "../../../../../global/constants/inputLimits";

function NonShipGatLoc() {
  const dispatch = useDispatch();
  const { formFields, alertGroupOptions,assetsList } = useSelector((state) => ({
    formFields: state.deviceProfile.ui.form.fields,
    alertGroupOptions: state.deviceProfile.ui.form.alertGroups,
    assetsList: state.deviceProfile.data.assetList,
  }));

  const [isInView, setIsInView] = useState({
    trigger: false,
    gatalertgroup: false,
    bleassettype: false
  });
  const useCaseValue = formFields?.nonshipstep3?.nonshipusecase?.useCase?.value || "";
  const handleFormField = (stateField, field, value) => {
    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            nonshipstep3: {
              ...formFields.nonshipstep3,
              [stateField]: {
                ...formFields.nonshipstep3[stateField],
                [field]: { value, isValid: true },
              },
            },
          },
        },
      })
    );
  };

const assettypeOptions = [
  ...new Set(
    (assetsList || [])
      .map(item => item.assettype)
      .filter(type => type && type.trim() !== "")
  )
].map(type => ({
  value: type,
  label: type
}));


  return (
      <ModalBody>
        {/* <div className="d-flex flex-column justify-content-start align-items-start mb-4">
          <div className="d-flex flex-row justify-content-start align-items-center gap-1">
            <Body size="small">Use case</Body>
          </div>
          <Input
              className={`shipment-form-fields`}
              value={useCaseValue}
              readOnly={true}
            />
        </div> */}
        <div className="d-flex flex-column justify-content-start align-items-start mb-4">
          <div className="d-flex flex-row justify-content-start align-items-center gap-1">
            <Body size="small">Asset type</Body>
            <Body size="small" color="#6F7171">
              Optional
            </Body>
          </div>
          <Select
              mode="multiple"
              className={`shipment-form-fields-alertGroup ${formFields?.nonshipstep3?.inventoryMgmt?.assettype?.class}`}
              allowClear
               value={
                formFields?.nonshipstep3.inventoryMgmt?.assettype?.value
              }
              onChange={(val) => handleFormField("inventoryMgmt", "assettype", val)}
              style={
                formFields?.nonshipstep3?.inventoryMgmt?.assettype?.value
                  ?.length > 0
                  ? {
                      width: "100%",
                      minHeight: "44px !important",
                    }
                  : {
                      width: "100%",
                      minHeight: "44px !important",
                    }
              }
              options={assettypeOptions}
            />
        </div>
        <div className="d-flex flex-column justify-content-start align-items-start mb-4">
          <div className="d-flex flex-row justify-content-start align-items-center gap-1">
            <Body size="small">Asset count threshold</Body>
             <Tooltip
                  title=""
                  size="medium"
                  surface="light"
                >
                  Set the asset count threshold that triggers an alert when the count falls below
                </Tooltip>
          </div>
           <Input
                 type="text"
                 name="assetthreshold"
                 id="assetthreshold"
                 className={`shipment-form-fields`}
                 value={formFields?.nonshipstep3?.inventoryMgmt?.assetthreshold?.value}
                 maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
                 onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    handleFormField("inventoryMgmt", "assetthreshold", e.target.value);
                  }
                }}
                 error={
                   !formFields?.step1?.profileName?.isValid ||
                   !!getCharLimitMsgDeviceProfile("CATEGORY_TEXT", formFields?.nonshipstep3?.inventoryMgmt?.assetthreshold?.value)
                 }
                 required={false}
                 errorText={
                   (!formFields?.nonshipstep3?.inventoryMgmt?.assetthreshold?.isValid && formFields?.nonshipstep3?.inventoryMgmt?.assetthreshold?.error) ||
                   getCharLimitMsgDeviceProfile("CATEGORY_TEXT", formFields?.nonshipstep3?.inventoryMgmt?.assetthreshold?.value) ||
                   ""
                 }
                  width="100%"
            />
        </div>
         <div className="d-flex justify-content-center align-items-center gap-4 mb-4">
                    <div className="w-100 d-flex flex-row">
                    <div className="w-50 pe-2">
                        <div className="d-flex flex-row align-items-center">
                       <Body size="small">Alert type</Body>
                        <Tooltip
                          title=""
                          size="medium"
                          surface="light"
                        >
                         Severity level of the alarm
                        </Tooltip>
                        </div>
                       <Input
                        className={`shipment-form-fields`}
                         value={"Notification"}
                        readOnly={true}
                      />
                    </div>
                    <div className="w-50">
                      <div className="d-flex flex-row align-items-center">
                       <Body size="small">Alert group</Body>
                        <Tooltip
                          title=""
                          size="medium"
                          surface="light"
                        >
                           Alert groups to be notified of the alarm
                        </Tooltip>
                        </div>
                       <Select
                        className={`shipment-form-fields-alertGroup ${formFields?.nonshipstep3?.inventoryMgmt?.alertgroup?.class}`}
                        key={"[stateSelectorIndex]-alert-group"}
                        placeholder="None"
                        mode="multiple"
                        allowClear
                        value={
                          formFields?.nonshipstep3.inventoryMgmt?.alertgroup?.value
                        }
                        onChange={(val) => handleFormField("inventoryMgmt", "alertgroup", val)}
                        style={
                          formFields?.nonshipstep3?.inventoryMgmt?.alertGroup?.value
                            ?.length > 0
                            ? {
                                width: "100%",
                                minHeight: "44px !important",
                              }
                            : {
                                width: "100%",
                                minHeight: "44px !important",
                              }
                        }
                        options={alertGroupOptions}
                      />
                    </div>
                  </div>
                </div>
      </ModalBody>
  );
}

export default NonShipGatLoc;